import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// The two typefaces, bundled with the shell rather than fetched from Google
// at run time. Only the subsets the till uses: Latin for Inter (English and
// every figure), Arabic and Latin for Cairo. Printing photographs the receipt
// with its fonts embedded, so a font that lives on the internet is a receipt
// that waits for the internet - see index.html.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/cairo/arabic-400.css';
import '@fontsource/cairo/arabic-500.css';
import '@fontsource/cairo/arabic-600.css';
import '@fontsource/cairo/arabic-700.css';
import '@fontsource/cairo/latin-400.css';
import '@fontsource/cairo/latin-500.css';
import '@fontsource/cairo/latin-600.css';
import '@fontsource/cairo/latin-700.css';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('The #root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
